import { getPointer } from "libs/schema";
import { PermissionError } from "libs/errors";
import { ADMIN_USER_ID } from "libs/shared-constants";
import { ActionServerContext } from "../action";

export async function authorizeUserCanUpdateInbox(props: {
  inboxSectionId: string;
  inboxSubsectionIds: string[];
  context: ActionServerContext;
}) {
  const {
    inboxSectionId,
    inboxSubsectionIds: incomingInboxSubsectionIds,
    context: {
      currentUserId,
      environment: { db, loader },
    },
  } = props;

  const [[userInboxSections], [userInboxSubsections], [existingInboxSubsectionTags]] = await Promise.all([
    loader.getInboxSections({ currentUserId }),
    loader.getInboxSubsections({ inboxSectionId, currentUserId }),
    db.getRecords(
      incomingInboxSubsectionIds.map((subsectionId) => getPointer("tag", subsectionId)),
      { includeSoftDeletes: true, currentUserId: ADMIN_USER_ID },
    ),
  ]);

  const userInboxSectionIds = new Set(userInboxSections.map((section) => section.id));
  const userSubsectionIds = new Set(userInboxSubsections.map((subsection) => subsection.id));
  const existingInboxSubsectionTagIds = new Set(existingInboxSubsectionTags.map((tag) => tag.id));

  if (!userInboxSectionIds.has(inboxSectionId)) {
    throw new PermissionError("User doesn't have access to the inbox section");
  }

  for (const incomingSubsectionId of incomingInboxSubsectionIds) {
    if (!userSubsectionIds.has(incomingSubsectionId) && existingInboxSubsectionTagIds.has(incomingSubsectionId)) {
      throw new PermissionError(
        `User doesn't have subsection ${incomingSubsectionId} in inbox ${inboxSectionId} but the tag:${incomingSubsectionId} exists`,
      );
    }
  }
}
